import * as React from 'react';
import { Modal } from '@roo/roo';
import utils from '@/utils/utils';
import { IModalProps, onlineService, OnlineStatusEnum } from '../api';

const { useState } = React;

const Index = (props: IModalProps) => {
    const { service, visible, handleClose, refresh } = props;
    const text = service?.onlineStatus === OnlineStatusEnum.offline ? '上架' : '下架';
    const [loading, setLoading] = useState<boolean>(false);

    const handleConfirm = () => {
        if (!service) return;
        const { serviceID, onlineStatus: old } = service;
        setLoading(true);
        const params = {
            serviceID,
            onlineStatus:
                old === OnlineStatusEnum.offline
                    ? OnlineStatusEnum.online
                    : OnlineStatusEnum.offline,
        };
        onlineService(params)
            .then(() => {
                utils.toast('success', '操作成功');
                handleClose();
                refresh();
            })
            .catch(() => {})
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Modal
            visible={visible}
            title={`${text}服务`}
            onCancel={() => {
                handleClose();
            }}
            onConfirm={() => {
                handleConfirm();
            }}
            confirmButtonProps={{ loading }}
        >
            <p>
                {service?.isNewItem === 1 ? (
                    <span>
                        该新服务保护期截至
                        {`"${utils.timestampToMinutes(service.newItemPassTime).date}"`}
                        ，若超出保护期则不再保护。
                    </span>
                ) : null}
                <span>确定要{text}此服务吗？</span>
            </p>
        </Modal>
    );
};

export default Index;
